import InfiniteScroll from "infinite-scroll";
import { enhance } from "@grrr/hansel";
import { imageEffect } from "./image_effect";

export const autoLoad = function (el) {
    const selector = "." + el.getAttribute("data-selector");
    const container = el.querySelector(".load-more__container");
    console.log(selector, container);
    let infScroll = new InfiniteScroll(container, {
        path: ".blocks__load-more a",
        append: selector,
        history: false,
    });

    infScroll.on("append", function (body, path, items, response) {
        items.forEach(function (item) {
            enhance(item, { imageEffect });
        });
    });
};
